import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const PriceBreakdownBlock = ({ items, additionalClass }) => {
  return (
    <div className={classNames("price-breakdown", additionalClass)}>
      {items.map(item => {
        return (
          <div className="price-item-line" key={item.title}>
            <div className="flex-block">
              {item.info ? (
                <div className="flex-block">
                  <p className="price-line-name">{item.title}</p>
                  <p className="price-info">{item.info}</p>
                </div>
              ) : (
                <p className="price-line-name">{item.title}</p>
              )}

              <p className="price-line-value">{item.value}</p>
            </div>
            {item.disclaimer && <p className="disclaimer-line">{item.disclaimer}</p>}
          </div>
        );
      })}
    </div>
  );
};

export default PriceBreakdownBlock;
